import { storeToRefs } from 'pinia';
import { nextTick } from 'vue';
import useOrdersCreateDataPreparedStore from '@/apps/order/stores/ordersCreate/OrdersCreateDataPreparedStore';

let alreadyFetched = false;

const hasCompanySettings = async (): Promise<void> => new Promise<void>((resolve, reject) => {
  nextTick(async () => {
    try {
      const dataPreparedStore = useOrdersCreateDataPreparedStore();
      const { companySettings } = storeToRefs(dataPreparedStore);

      if (companySettings.value !== undefined) {
        resolve();
        return;
      }

      if (!alreadyFetched) {
        await dataPreparedStore.fetchCompanySetting();
        alreadyFetched = true;
        resolve();
      }
      resolve();
    } catch (e) {
      reject(new Error('fetch company setting failed'));
    }
  });
});

export default hasCompanySettings;
